import 'css-chunksrc/client/pages/personalSpacePage/timeSheet/styles.scss';export default {
  "timeSheetPage": "_timeSheetPage_lm31a_1",
  "filters": "_filters_lm31a_8",
  "header": "_header_lm31a_19",
  "row": "_row_lm31a_35",
  "footer": "_footer_lm31a_49",
  "filtersLeft": "_filtersLeft_lm31a_53",
  "filtersRight": "_filtersRight_lm31a_60",
  "teamAllocations": "_teamAllocations_lm31a_66",
  "button": "_button_lm31a_70",
  "icon": "_icon_lm31a_90",
  "teamSubordinatesFlag": "_teamSubordinatesFlag_lm31a_98"
};